module.exports = __webpack_public_path__ + "img/ef3a352.png";